const translations = {
  en: {
    welcome: "Welcome",
    signInAccount: "Sign in to your account",
    emailAddress: "Email or Phone Number",
    enterEmail: "Enter your email or phone number",
    password: "Password",
    enterPassword: "Enter your password",
    rememberMe: "Remember Me",
    forgotPassword: "Forgot password?",
    signIn: "Sign In",
    processing: "Processing...",

    // Modal
    resetPassword: "Reset Password",
    resetPasswordSubtitle:
      "Enter your email address and we'll send you instructions to reset your password",
    // Password reset is still email-only (no SMS delivery), so this modal
    // keeps its own copy instead of the shared sign-in label/placeholder,
    // which now mention phone numbers too.
    resetEmailLabel: "Email Address",
    resetEnterEmail: "Enter your email",
    sendResetLink: "Send Reset Link",
    sending: "Sending...",
    sentSuccessfully: "Sent Successfully",
    cancel: "Cancel",

    // Forced password change (phone-only account, first login)
    forcePasswordTitle: "Set a New Password",
    forcePasswordSubtitle:
      "Your account was created with a phone number and a temporary password. Please set your own password to continue.",
    forcePasswordNewLabel: "New Password",
    forcePasswordNewPlaceholder: "Enter a new password",
    forcePasswordConfirmLabel: "Confirm New Password",
    forcePasswordConfirmPlaceholder: "Re-enter the new password",
    forcePasswordSubmit: "Set Password & Continue",
    forcePasswordLogoutInstead: "Log Out Instead",
    forcePasswordTooShort: "Password must be at least 6 characters",
    forcePasswordMismatch: "Passwords do not match",

    // Messages
    fillAllFields: "Please fill in all required fields",
    geolocationNotSupported: "Geolocation is not supported by your browser",
    loginNotAllowed: "Login not allowed outside the permitted area",
    firstLoginDetected:
      "First-time login detected. Please check your email for password reset instructions.",
    noPermission: "You do not have permission to access this system",
    loginSuccessful: "Login successful!",
    subscriptionNotFound:
      "Company subscription not found. Please contact support.",
    subscriptionInactive:
      "Company subscription is inactive. Please contact your administrator.",
    subscriptionExpired:
      "Company subscription has expired. Please renew to continue.",
    subscriptionValidationFailed: "Subscription validation failed.",
    invalidCredentials: "Invalid email/phone or password",
    networkError: "Network error, please try again",
    unableToFetchLocation: "Unable to fetch location. Please allow access.",
    validEmailRequired: "Please enter a valid email address",
    resetInstructionsSent:
      "Password reset instructions have been sent to your email. Please check your inbox.",
    resetInstructionsFailed:
      "Failed to send reset instructions. Please try again.",
    networkErrorReset:
      "Network error. Please check your connection and try again.",
    loadingSplash: "Loading your experience...",
    redirectingSoon: "Redirecting you now...",
    splashAltText: "Client splash screen",
  },
  ar: {
    welcome: "مرحباً",
    signInAccount: "تسجيل الدخول إلى حسابك",
    emailAddress: "البريد الإلكتروني أو رقم الهاتف",
    enterEmail: "أدخل بريدك الإلكتروني أو رقم هاتفك",
    password: "كلمة المرور",
    enterPassword: "أدخل كلمة المرور",
    rememberMe: "تذكرني",
    forgotPassword: "نسيت كلمة المرور؟",
    signIn: "تسجيل الدخول",
    processing: "جاري المعالجة...",

    // Modal
    resetPassword: "إعادة تعيين كلمة المرور",
    resetPasswordSubtitle:
      "أدخل عنوان بريدك الإلكتروني وسنرسل لك تعليمات لإعادة تعيين كلمة المرور",
    resetEmailLabel: "البريد الإلكتروني",
    resetEnterEmail: "أدخل بريدك الإلكتروني",
    sendResetLink: "إرسال رابط إعادة التعيين",
    sending: "جاري الإرسال...",
    sentSuccessfully: "تم الإرسال بنجاح",
    cancel: "إلغاء",

    // Forced password change (phone-only account, first login)
    forcePasswordTitle: "قم بتعيين كلمة مرور جديدة",
    forcePasswordSubtitle:
      "تم إنشاء حسابك برقم هاتف وكلمة مرور مؤقتة. يرجى تعيين كلمة المرور الخاصة بك للمتابعة.",
    forcePasswordNewLabel: "كلمة المرور الجديدة",
    forcePasswordNewPlaceholder: "أدخل كلمة مرور جديدة",
    forcePasswordConfirmLabel: "تأكيد كلمة المرور الجديدة",
    forcePasswordConfirmPlaceholder: "أعد إدخال كلمة المرور الجديدة",
    forcePasswordSubmit: "تعيين كلمة المرور والمتابعة",
    forcePasswordLogoutInstead: "تسجيل الخروج بدلاً من ذلك",
    forcePasswordTooShort: "يجب أن تتكون كلمة المرور من 6 أحرف على الأقل",
    forcePasswordMismatch: "كلمتا المرور غير متطابقتين",

    // Messages
    fillAllFields: "يرجى ملء جميع الحقول المطلوبة",
    geolocationNotSupported: "الموقع الجغرافي غير مدعوم في متصفحك",
    loginNotAllowed: "تسجيل الدخول غير مسموح به خارج المنطقة المحددة",
    firstLoginDetected:
      "تم اكتشاف تسجيل دخول لأول مرة. يرجى التحقق من بريدك الإلكتروني للحصول على تعليمات إعادة تعيين كلمة المرور.",
    noPermission: "ليس لديك إذن للوصول إلى هذا النظام",
    loginSuccessful: "تم تسجيل الدخول بنجاح!",
    subscriptionNotFound:
      "لم يتم العثور على اشتراك الشركة. يرجى الاتصال بالدعم.",
    subscriptionInactive: "اشتراك الشركة غير نشط. يرجى الاتصال بالمسؤول.",
    subscriptionExpired: "انتهت صلاحية اشتراك الشركة. يرجى التجديد للمتابعة.",
    subscriptionValidationFailed: "فشل التحقق من الاشتراك.",
    invalidCredentials: "البريد الإلكتروني أو رقم الهاتف أو كلمة المرور غير صحيحة",
    networkError: "خطأ في الشبكة، يرجى المحاولة مرة أخرى",
    unableToFetchLocation: "تعذر الحصول على الموقع. يرجى السماح بالوصول.",
    validEmailRequired: "يرجى إدخال عنوان بريد إلكتروني صالح",
    resetInstructionsSent:
      "تم إرسال تعليمات إعادة تعيين كلمة المرور إلى بريدك الإلكتروني. يرجى التحقق من صندوق الوارد.",
    resetInstructionsFailed:
      "فشل إرسال تعليمات إعادة التعيين. يرجى المحاولة مرة أخرى.",
    networkErrorReset:
      "خطأ في الشبكة. يرجى التحقق من اتصالك والمحاولة مرة أخرى.",
    loadingSplash: "جارٍ تحميل شاشتك المخصصة...",
    redirectingSoon: "سيتم تحويلك الآن...",
    splashAltText: "شاشة الترحيب الخاصة بالشركة",
  },
};

export default translations;